import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {AudioRecordItemComponent} from './audio-record-item.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {ButtonModule} from '../../../../../../core/component/button/button.module';
import {
    ConfirmationButtonModule
} from '../../../../../../../components/common/button/confirmation-button/confirmation-button.module';
import {ItemModule} from '../../../../../../core/component/item/item.module';
import {SummaryModule} from '../../../../../../core/component/summary/summary.module';
import {SummaryFieldModule} from '../../../../../../core/component/summary-field/summary-field.module';
import {LoadingModule} from "../../../../../../../components/common/loading/loading.module";
import {ErrorTextModule} from "../../../../../../core/component/error-text/error-text.module";
import {MatSliderModule} from "@angular/material/slider";
import {
    PartnerSummaryFieldModule
} from "../../../../../../partner/common/api/component/partner-summary-field/partner-summary-field.module";
import {
    DatetimeSummaryFieldModule
} from "../../../../../../core/component/date/datetime-summary-field/datetime-summary-field.module";
import {
    DocumentSummaryModelFieldModule
} from "../../../../../../document/common/api/component/document-summary-field/document-summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ButtonModule,
        ConfirmationButtonModule,
        ItemModule,
        SummaryModule,
        SummaryFieldModule,
        MatProgressBarModule,
        LoadingModule,
        ErrorTextModule,
        MatSliderModule,
        PartnerSummaryFieldModule,
        DatetimeSummaryFieldModule,
        DocumentSummaryModelFieldModule,
    ],
    declarations: [
        AudioRecordItemComponent
    ],
    exports: [
        AudioRecordItemComponent
    ],
})
export class AudioRecordItemModule {
}
